
const React = require('react');
const FavoritesListing = require('./favorites.listing.jsx').FavoritesListing;
const Marketing = require('./marketing.jsx').Marketing;

const App = React.createClass({

    getInitialState: function () {
        let state = {};
        state.account = this.props.account;
        state.account.Name = (state.account && state.account.Name)?state.account.Name:'Farm List';
        return state;
    },

    render: function() {

        if (this.state.account) {
                return (
                    <div className="wrapper with-margin">
                        <main className="content with-relative">
                            <FavoritesListing account={this.state.account} favorites={this.props.favorites} public="true" isMarket="false"/>
                        </main>
                        <Marketing/>
                    </div>
                )
        }
        else {
            return (
                <div className="wrapper with-margin">
                    <main className="content with-relative">
                        <div className="expired large-white-box">
                            <span>Market Listing could not be found.  Please contact your market directly.</span>
                        </div>
                    </main>
                    <Marketing/>
                </div>
            );
        }
    }
});

exports.App = App;

